import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { DetalleOrdenCompraDTO } from "app/main/apps/shared/interfaces/detalle-orden-compra.interface";
import { RecepcionDTO } from "app/main/apps/shared/interfaces/recepcion.interface";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-ficha-oocc",
    templateUrl: "./ficha-oocc.component.html",
    styleUrls: ["./ficha-oocc.component.scss"],
})
export class FichaOoccComponent implements OnInit {
    esRepresentante: boolean = false;
    esSupervisor: boolean = false;
    @ViewChild("fileInput") fileInput: ElementRef<HTMLInputElement>;
    

    @Input() oocc: DetalleOrdenCompraDTO;
    @Input() recepcion: RecepcionDTO;

    @Output() adjuntarInformeEvent: EventEmitter<number> = new EventEmitter();
    @Output() anularEvent: EventEmitter<number> = new EventEmitter();
    @Output() bajarDocumentoEvent: EventEmitter<number> = new EventEmitter();
    @Output() bajarInformeEvent: EventEmitter<number> = new EventEmitter();
    @Output() guardarRocGesEvent: EventEmitter<{
        numeroGes: string;
        nuevo: boolean;
    }> = new EventEmitter();

    constructor(private _menuUsuarioSrvc: MenuUsuarioService) {}

    ngOnInit(): void {
        this.esRepresentante = this._menuUsuarioSrvc.esRepresentante();
        this.esSupervisor = this._menuUsuarioSrvc.esSupervisor();

    }

    anular(idOOCC: number) {
        this.anularEvent.emit(idOOCC);
    }

    guardarRocGes(numeroGes: string) {
        const data = {
            numeroGes: numeroGes,
            nuevo: numeroGes ? false : true,
        };
        this.guardarRocGesEvent.emit(data);
    }

    bajarDocumento(idOOCC:number){
        //console.log(idOOCC);
        this.bajarDocumentoEvent.emit(idOOCC);
    }    

    bajarInforme(idOOCC:number){
        //console.log(idOOCC);
        this.bajarInformeEvent.emit(idOOCC);
    }    

    abrirDialogoCargarInforme(idOOCC:number){
        this.adjuntarInformeEvent.emit(idOOCC);
    }
}
